import { render } from "./EgressRulesTab.vue?vue&type=template&id=2f561cfe&scoped=true"
import script from "./EgressRulesTab.vue?vue&type=script&lang=js"
export * from "./EgressRulesTab.vue?vue&type=script&lang=js"

import "./EgressRulesTab.vue?vue&type=style&index=0&id=2f561cfe&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f561cfe"]])

export default __exports__